// removed by extract-text-webpack-plugin
module.exports = {"block":"_1DXZcEv7BoD9sGZRVBnR7e","bg":"_1wWeWa1cEmeh8WGBCokznq","tall":"_2t2J_r3KiS7eb7O-3BYC0P","block-content":"_2LmZFrTaWqxT_uyf61budY","list-content":"_1PrH9D0-gb4EzIBEwO6fak","heading":"EM75195_OuFoWH96duidj","text":"_3Vf7SSCnfN4Qe5ZtG3diXa","zebra":"_38yi4sw4LJop1xhk9kOh47","yellow":"_24bca3tIYuOkSxbWLC-Vys","darkgray":"_2hb-LlWRsFBk20ZMVbMHOU","video":"_1pmyKuUujJuoCXWd_c5v_X","links":"_3YNzAaiQJUMRYDFthAlEOj","videoplayer":"gKOtKzXKfDlKXiBVgn-4W","icon":"_3Kf6ZL9JyzvwjJzPFovBXp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkListBlock/LinkListBlock.module.scss
// module id = 784
// module chunks = 0